import { view } from "@risingstack/react-easy-state";
import { Accordion } from "@tine/designsystem-ui-react";
import { sendAccordionClick } from "../../../common/tracking";
import type { ContentfulAccordion } from "../../../common/types/cmsTypes";
import RichTextRenderer from "../RichTextRenderer";

type AccordionProps = {
   accordionContent: ContentfulAccordion;
};

const CmsAccordion = ({ accordionContent }: AccordionProps) => {
   const title = accordionContent.fields.title;
   const content = accordionContent.fields.content;

   return (
      <section aria-label={title}>
         <button
            type="button"
            onClick={() => sendAccordionClick(title)}
            onKeyDown={(e) => {
               if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  sendAccordionClick(title);
               }
            }}
            className="tw-w-full tw-text-left"
         >
            <Accordion label={title} borderVariant="none">
               <RichTextRenderer document={content} context="simple-article" variant="simple" />
            </Accordion>
         </button>
      </section>
   );
};

export default view(CmsAccordion);
